<template>
  <main class="container-fluid" :class="{'section-loading': loading, 'boxPadding': isBox}">
    <section>
      <h4 class="text-green">
        篩選結果：{{this.totalCustCount}}位客戶
        <div class="dropdown float-right">
          <button class="btn btn-default btn-sm m-0" aria-expanded="false" aria-haspopup="true"  data-toggle="dropdown" @click="dropmenuOpen = !dropmenuOpen">功能<i v-if="dropmenuOpen===false" class="icon-collapse_down"></i><i v-else class="icon-collapse_up"></i></button>
          <div class="dropdown-menu  dropdown-menu-left">
            <a @click="toSearchFilter" role="button" class="dropdown-item text-green text-underline">修改條件</a>
            <a @click="SearchResultOpen" role="button" class="dropdown-item text-green text-underline">目前篩選條件</a>
            <a @click="SearchResultFarvoriteOpen" role="button" class="dropdown-item text-green text-underline">加入我的最愛</a>
          </div>
        </div>
        <div class="dropdown float-right" style="margin-right: 4px;">
          <button class="btn btn-default btn-sm m-0" aria-expanded="false" aria-haspopup="true"  data-toggle="dropdown" @click="dropmenuOpen = !dropmenuOpen">生日排序方式<i v-if="dropmenuOpen===false" class="icon-collapse_down"></i><i v-else class="icon-collapse_up"></i></button>
          <div class="dropdown-menu dropdown-menu-left w-180">
              <div class="radio radio-inline">
                <input
                  type="radio"
                  name="birthday-radio"
                  id="sort-radio1"
                  v-model="birthday_sort"
                  value="1"
                  @click="changeBirthdaySort('1')"
                />
                <label for="sort-radio1" class="text-green text-underline">以年-月-日排序</label>
              </div>
              <div class="radio radio-inline">
                <input
                  type="radio"
                  name="birthday-radio"
                  id="sort-radio2"
                  v-model="birthday_sort"
                  value="2"
                  @click="changeBirthdaySort('2')"
                />
                <label for="sort-radio2" class="text-green text-underline">以月-日-年排序</label>
              </div>
          </div>
        </div>
      </h4>
      
    </section>
    <section>
     <div class="form-group row search-checkbox " style="margin-bottom:0px;margin: 0px 0;">
        <label class="d-inline-block pt-2">客戶類型(可複選)：</label>
        <div class="checkbox checkbox-inline">
          <input
          type="checkbox"
          name="customer"
          id="customer-1"
          value="1"
          v-model="customerType">
          <label for="customer-1">壽險客戶</label>
        </div>
        <div class="checkbox checkbox-inline">
          <input
          type="checkbox"
          name="customer"
          id="customer-3"
          value="3"
          v-model="customerType">
          <label for="customer-3">旅平險客戶</label>
        </div>
        <div class="checkbox checkbox-inline">
          <input
          type="checkbox"
          name="customer"
          id="customer-4"
          value="4"
          v-model="customerType">
          <label for="customer-4">房貸客戶</label>
        </div>
        <div class="checkbox checkbox-inline">
          <input
          type="checkbox"
          name="customer"
          id="customer-5"
          value="5"
          v-model="customerType">
          <label for="customer-5">團險客戶</label>
        </div>
        <div class="checkbox checkbox-inline">
          <input
          type="checkbox"
          name="customer"
          id="customer-6"
          value="6"
          v-model="customerType">
          <label for="customer-6">準保戶</label>
        </div>
      </div>
    </section>
    <section>
    <div class="container-fluid">
      <div class="row">
      <!-- kerry test -->
        <data-table style="width: 78rem;" ref="dataTable"
        @update="updateSelection"
        @updateall="updateSelectAll"
        @openInfoModal="openCathayCustInfoModal"
        @openSurveyModal="openCathaySurveyModal"
        :options="tableOption" 
        :table-data="tableDataBackup"
        :currentPage="currentPage"
        :totalpages="totalpages"
        :addPageStatus="addPageStatus"
        :scroll-data-loading="scrollDataLoading"
        :scroll-message-loading="scrollMessageLoading"
        :remote-data-msg="remoteDataMsg"
        :dynamicLoading="true"
        :isShowSurvey="true"
        :birthdaySortingType="birthday_sort"
        :is_open_mkt_type="is_open_mkt_type" />
      </div>
      <!-- <div class="list inline">
        <div style="margin-right: 4px;" class="item">
          <span class="tag-box">要</span>
          <small class="text">壽險要保人</small>
        </div>
        <div style="margin-right: 4px;" class="item">
          <span class="tag-box">被</span>
          <small class="text">壽險主被保人</small>
        </div>
        <div style="margin-right: 4px;" class="item">
          <span class="tag-box">意</span>
          <small class="text">意外被保險人</small>
        </div>
        <div style="margin-right: 4px;" class="item">
          <span class="tag-box">團</span>
          <small class="text">團險被保人</small>
        </div>
        <div style="margin-right: 4px;" class="item">
          <span class="tag-box">借</span>
          <small class="text">房貸借款人</small>
        </div>
      </div> -->
    </div>
    </section>

    <section class="container-fluid">
      <fixed-botton v-show="!isScroll">
        <template slot="@function">
          <div>
            <button class="btn btn-default"
              v-if="showDeleteBtn"
              @click="deleteResult"
              :disabled="!selection.length">
              刪除客戶
            </button>
            <button class="btn btn-primary"
              @click="panelOpen('confirmGroupModalOpen')"
              :disabled="!selection.length">
              加入群組
            </button>
            <button class="btn btn-primary mr-0"
              @click="openPrintModal"
              :disabled="!selection.length">
              列印名條
            </button>
          </div>
        </template>
      </fixed-botton>
    </section>

    <warning-modal
    :open="WarningModalOpen"
    :message="deleteWarningMessage"
    @close="panelClose('WarningModalOpen')"
    @submit="submitDeleteResult"/>

    <warning-modal
    :open="WarningDoubleCheckModalOpen"
    :message="WarningDoubleCheckModalMessage"
    :confirmText="`確認刪除`"
    @close="panelClose('WarningDoubleCheckModalOpen')"
    @submit="deleteCustomer"/>

    <print-modal
    :open="printModalOpen"
    :custs="selectionWithMobile"
    @close="panelClose('printModalOpen')"/>

    <group-modal
    :open="groupModalOpen"
    :custs="selection"
    @submit="submitGroup"
    @close="panelClose('groupModalOpen')"/>

    <search-result-modal
    :open="searchResultModalOpen"
    :filters="filtersProdCode"
    :title="searchResultTitle"
    @close="panelClose('searchResultModalOpen')"/>
    
    <search-result-farvorite-modal
    :open="searchResultFarvoriteOpen"
    @submit="submitFarvorite"
    @close="panelClose('searchResultFarvoriteOpen')"/>

    <!-- 確認加入群組類型視窗 -->
    <confirm-group-modal
      :open="confirmGroupModalOpen"
      title="請選擇加入群組方式"
      @close="panelClose('confirmGroupModalOpen')"
      @addToCurrentGroup="addToCurrentGroup"
      @createNewGroup="createOneGroupOpen"
    />

    <!-- 成立新的群組視窗 -->
    <create-one-group-modal
      :open="createOneGroupModalOpen"
      :selectedCust="selection"
      type="FilterResultUse"
      @close="panelClose('createOneGroupModalOpen')"
      @createOneGroup="createOneGroup"
    />

    <!-- 泰好客說明視窗 -->
    <cathay-cust-info-modal
      :open="cathayCustInfoModalOpen"
      @close="panelClose('cathayCustInfoModalOpen')"
    />

    <!-- 問卷視窗 -->
    <survey-modal
      :open="surveyModalOpen"
      :csid="selectedCustID"
      @refresh="doRefresh"
      @close="panelClose('surveyModalOpen')"
    />

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="maskContent" />
  </main>
</template>

<script>
import {commonMixin} from '@/mixins/common'
import {mapActions, mapGetters} from 'vuex'
import PrintModal from '../components/PrintModal'
import GroupModal from '../components/GroupModal'
import Avatar from '../../components/Avatar'
import Level from '../../components/Level'
import SearchResultModal from '@/desktop/components/SearchResultModal'
import SearchResultFarvoriteModal from '@/desktop/components/SearchResultFarvoriteModal'
import WarningModal from '../components/WarningModal'
import WarningDoubleCheckModal from '../components/WarningModal'
import {queryCustListByCustomized, insertFavorite, deleteCust, doSortList, getCustHasFamily, insertBirthSort, deleteBirthSort} from '../../service'
import moment from "moment"
import DataTable from '../../components/DataTable/DataTableScroll'
import FixedBotton from '../components/fixedBotton'
import mxMask from "@/desktop/components/mxMask"
import ConfirmGroupModal from "@/desktop/components/ConfirmGroupModal"
import CreateOneGroupModal from "@/desktop/components/CreateOneGroupModal"
import CathayCustInfoModal from "@/desktop/components/CathayCustInfoModal"
import SurveyModal from "@/desktop/components/SurveyModal"

const is_iPad = navigator.userAgent.match(/iPad/i) != null // 確認裝置是否為 iPad
let windowWidth = -530;
if(is_iPad){
  windowWidth = -480;
}

export default {
  name: 'FilterResult',
  mixins: [commonMixin],
  watch: {
    checkAll: function(val){
      if(val && this.checkAllClick) {
        this.selection = []
        this.tableDataBackup.forEach(data => {
          this.selection.push(data.id);
        });
      } else if(this.checkAllClick){
        this.selection = []
      }
    },
    selection: function(){
      if(this.tableDataBackup.length == 0) {
        this.checkAll = false
      }else if(this.tableDataBackup.length !== this.selection.length && !this.checkAllClick){
        this.checkAll = false
      }else if(!this.checkAllClick){
        this.checkAll = true
      }
    },
    customerType: function(newAry) {
      this.$store.dispatch("updaCustType", newAry);
      var val = newAry.find(function(e) {
        return e == 6;
      });
      if (newAry.length == 1 && val == 6) {
        this.showDeleteBtn = true;
      } else {
        this.showDeleteBtn = false;
      }
      this.filterByType();
    }
  },  
  components: {
    PrintModal, GroupModal, Avatar, Level, SearchResultModal, SearchResultFarvoriteModal,WarningModal,WarningDoubleCheckModal,DataTable,FixedBotton, mxMask, ConfirmGroupModal, CreateOneGroupModal, CathayCustInfoModal, SurveyModal
  },
  computed: {
    ...mapGetters(['BaseUrl', 'RouterPara', 'UserInfo']),
    // 計算篩選結果客戶數量
    totalCustCount () {
      return this.tableDataBackup.length
    },
    isBox() {
      return this.UserInfo.userType === 'box';
    }
  },
  data () {
    return {
      remoteDataMsg: "資料讀取中，請稍候...",
      filters: [],
      filtersProdCode: [], //目前篩選條件頁面用
      loading: false,
      groupModalOpen: false,
      printModalOpen: false,
      checkAllClick: false,
      WarningModalOpen:false,
      WarningDoubleCheckModalOpen:false,
      checkAll: false,
      selection: [],
      selectionWithMobile: [],
      customerType: ['1','2','3','4','5','6'],
      tableData: [],
      searchResultModalOpen: false,
      searchResultTitle: '',
      searchResultFarvoriteOpen: false,
      data_table_height: 0,
      dropmenuOpen: false,
      tableDataBackup: [],
      order:{
        order_by:'2',
        order_asc: true,
      },
      showDeleteBtn: false,
      deleteWarningMessage:"您確定要刪除這些「準保戶」的客戶嗎？",
      WarningDoubleCheckModalMessage:"系統會同步刪除「<span style='color:red;'>客戶情報</span>」、「<span style='color:red;'>保單健檢</span>」及「<span style='color:red;'>建議書</span>」相關資訊，確認刪除後資料將無法回復，請確認是否刪除？",
      addPageStatus: false,
      page:'1',
      pageSize: 99999,
      currentPage: 0,
      scrollDataLoading: false,
      scrollMessageLoading: false,
      totalpages: 0,
      checkAll_f: false,
      isScroll: false, //是否滾動
      tableOption: {
        checkAll: true,
        scrollHeight: 350,
        isScrollLoading: true,
        checkBoxHasUser: true,
        columns: [
          {
            width: 110,
            name: "name",
            label: "姓名",
            sorting: true,
            click: (data) => {
              this.routeToCustDetail(data.id, data.name);
            }
          },
          {
            width: 120,
            name: "showid",
            label: "身分證",
            sorting: true
          },
          {
            width: 120,
            name: "mobile",
            label: "手機",
            sorting: true
          },
          {
            width: 100,
            name: "birthday",
            label: "生日",
            sorting: true
          },
          {
            name: "address",
            sorting: true,
            label: "住家地址"
          },
          {
            width:151,
            name: "mkt_type",
            key:"filter_result",
            label:"泰好客",
            sorting: true
          },
          {
            width: 101,
            name: "idmark",
            label: "公司往來"
          }
        ],
        sortByName: () => {
          this.order.order_asc = !this.order.order_asc
          this.sortByName();
        },
        scrollLoadingAPI: () => {
          this.scrollDataLoading = true;
          this.scrollMessageLoading = true;
          this.currentPage = this.currentPage + 1;
          this.getCustomersPageNew();
        }
      },
      bottomWidth: windowWidth,
      mxMaskOpen: false,
      maskContent:"", //遮罩顯示訊息
      birthday_sort:"1", //生日排序方式(1:年-月-日 2:月-日-年)
      confirmGroupModalOpen: false,
      createOneGroupModalOpen: false,
      cathayCustInfoModalOpen: false,
      surveyModalOpen: false, //問卷視窗開啟
      selectedCustID:"", //點選的客戶ID
      is_open_mkt_type: "N" //是否開啟行銷分
    }
  },
  methods: {
    ...mapActions([
      'setPageLock' , 'updateCustID'
    ]),
    updateSelection (val) {
      this.selection = val
    },
    updateSelectAll (val) {
      this.checkAll_f = val
    },    
    deleteResult(){
      this.panelOpen('WarningModalOpen')
    },
    submitDeleteResult(){
      this.panelClose('WarningModalOpen')
      this.panelOpen('WarningDoubleCheckModalOpen')
    },
    getCustomersAndSetup() {
      this.selection = []
      let conditionsObj = new Object;
      if(this.$route.query && (this.$route.query.field_name || this.$route.query.option || this.$route.query.tilte)){
        const {field_name, option, tilte} = this.$route.query
        if(!field_name || !option || !tilte) {
          this.$toast.info({title: '「客戶列表」搜尋失敗'})
          return
        }
        this.filters.push(tilte)
        conditionsObj[field_name] = option
      }else if(this.RouterPara.filterResult && this.RouterPara.filterResult[0].field_name){
        this.RouterPara.filterResult.forEach(item => {
          let eachCondition = item
          if(eachCondition.title && this.filters.indexOf(eachCondition.title) === -1){
            this.filters.push(eachCondition.title)
          }
          conditionsObj[eachCondition.field_name] = eachCondition.option
        })
        // this.$store.dispatch('updateFilterData', this.RouterPara.filterResult)
      }else{
        this.$store.state.filterData.forEach(item => {
          let eachCondition = item
          if(eachCondition.title && this.filters.indexOf(eachCondition.title) === -1){
            this.filters.push(eachCondition.title)
          }
          conditionsObj[eachCondition.field_name] = eachCondition.option
        })
      }
      this.getFiltersProdCode(); //設定filtersProdCode
      conditionsObj['order_asc']=this.order.order_asc ? 1 : 2;//2020/06/01 增加排序條件
      conditionsObj['order_by']=this.order.order_by;
      this.remoteDataMsg="資料讀取中，請稍候..."  
      let option_ch = this.filters.join(';')
      queryCustListByCustomized(this.$store.state.userInfo.id, conditionsObj, option_ch).then(result => {
        if(result.header.status && result.header.status == '200') {
          let resBody = result.body || {};
          this.is_open_mkt_type = resBody.is_open || "N"; //是否開啟行銷分
          if(resBody.customer_list && resBody.customer_list.length) {
            this.totalpages = Math.floor((this.tableDataBackup / 200) + 1);
            this.tableData = resBody.customer_list.map(eachCust => {
              let idmarkSource1 = eachCust.idmark.source1 && eachCust.idmark.source1 == '1' ? '1': 'N'
              let idmarkSource2 = eachCust.idmark.source2 && eachCust.idmark.source2 == '1' ? '2': 'N'
              let idmarkSource3 = eachCust.idmark.source3 && eachCust.idmark.source3 == '1' ? '3': 'N'
              let idmarkSource4 = eachCust.idmark.source4 && eachCust.idmark.source4 == '1' ? '4': 'N'
              let idmarkSource5 = eachCust.idmark.source5 && eachCust.idmark.source5 == '1' ? '5': 'N'
              let idmarkSource6 = eachCust.idmark.source6 && eachCust.idmark.source6 == '1' ? '6': 'N'
              eachCust.sourceFilter = []
              for (let i = 1; i < 7; i++) {
                if (eachCust.source[`source${i}`] !== '0') {
                  eachCust.sourceFilter.push(`${i}`)
                }
              }
              let val = eachCust.address
              if(val && val.trim() && val !== '— —'){
                let pattern = /^[0-9]+$/;
                let firstWords = val.substring(0, 5)
                let len = val.length;
                if (pattern.test(firstWords)) {
                  let words = val.substring(5, len);
                  val = eachCust.address.substring(0, 3);
                  val = val + words;          
                }else{
                  val = eachCust.address; 
                }
              }
              let ageText = this.paddingLeft(eachCust.idage == "0" ? "0" : eachCust.idage ? eachCust.idage : "00000", 4, "0");
              let birthdayText = eachCust.birthday || "0000-01-01";
              return {
                index: eachCust.index || '',
                vip_level : Number(eachCust.vip_lvl) || 0,
                sex : Number(eachCust.sex) || 0,
                name : eachCust.name || '',
                id : eachCust.id,
                showid : eachCust.id,
                mobile : eachCust.mobile || '',
                phone : eachCust.phone || '',
                birthday : eachCust.birthday || '',
                address : val || '',
                company_address : eachCust.company_address || '',
                idmark : [idmarkSource1, idmarkSource2, idmarkSource3, idmarkSource4, idmarkSource5, idmarkSource6],
                idage : eachCust.idage,
                age : eachCust.idage,
                sourceFilter: eachCust.sourceFilter,
                birthdaySort : ageText + "_" + birthdayText,
                customertype1:eachCust.source ? eachCust.source.source1 || '' : '',
                is_lia: eachCust.is_lia || '',
                hos_mkt_level: eachCust.hos_mkt_level || '',
                sur_mkt_level: eachCust.sur_mkt_level || '',
                rei_mkt_level: eachCust.rei_mkt_level || '',
                acc_mkt_level: eachCust.acc_mkt_level || '',
                dd_mkt_level: eachCust.dd_mkt_level || '',
                ltc_mkt_level: eachCust.ltc_mkt_level || '',
                life_mkt_level: eachCust.life_mkt_level || '',
                sav_mkt_level: eachCust.sav_mkt_level || '', 
                inv_mkt_level: eachCust.inv_mkt_level || '',
                crm_highlight: eachCust.crm_highlight || '',
                box_highlight: eachCust.box_highlight || '',      
                mkt_score : this.getMktScore(eachCust)
              }
            })
          } else {
            this.$toast.info({title: '查無資料'})
          }

          this.tableDataBackup = this.tableData.slice(0, this.pageSize);
          this.currentPage = 1;
          if(this.currentPage == this.totalpages){
            this.scrollDataLoading = true;
            this.scrollMessageLoading = false;
          }else{
            this.scrollMessageLoading = false;
          }

        } else {
          this.$toast.info({title: '「客戶列表」搜尋失敗'})
        }
        this.registerHanlink()  // 難字 update
        this.remoteDataMsg="查無資料，請確認您輸入之資料是否正確"

        //若客戶類型篩選設定有異動過，要保留前次設定內容
        let chkCustType = this.$store.state.custType;
        if (
          chkCustType &&
          (!chkCustType.includes("1") ||
            !chkCustType.includes("2") ||
            !chkCustType.includes("3") ||
            !chkCustType.includes("4") ||
            !chkCustType.includes("5") ||
            !chkCustType.includes("6"))
        ) {
          this.customerType = chkCustType;
        }
      })
      this.tableOption.scrollHeight = $(window).height() - 240;

      //查詢預設生日排序
      getCustHasFamily(this.$store.state.userInfo.id, "N").then(result => {
        if(result.header && result.header.status === "200" && result.body.birthsort) {
          this.birthday_sort = result.body.birthsort;//預設生日排序
        }
      });
    },
    submitGroup (group) {
      // add group methods
      this.panelClose('groupModalOpen')
      this.$router.push({path:`/group/1`, query:{grp_id: group.grp_id, grp_name: group.grp_name}})
    },
    toSearchFilter(){  // 修改條件
      let filterData = this.RouterPara.filterResult
      this.$router.push({ path: '/search-filter', query: filterData })
    },
    routeToCustDetail(custId, custName) {
      if (this.isBox) {
        this.boxCustInfo(custId, custName);
      } else {
        this.updateCustID(custId);
        localStorage.CustID = custId;
        this.$router.push({path: `/detail/CustID/tab/1`});
      }
    },
    SearchResultOpen() {
      this.searchResultTitle = '目前篩選條件: ' + this.filters.length + '個';
      this.panelOpen('searchResultModalOpen')
    },
    SearchResultFarvoriteOpen() {
      this.panelOpen('searchResultFarvoriteOpen')
    },
    submitFarvorite(favorName) {   // 新增我的最愛
      this.loading = true
      let field_name = []
      let option = []
      let option_ch = []
      let favorite_name = favorName

      this.$store.state.routerPara.filterResult.forEach(item => {
        field_name.push(item.field_name)
        option.push(item.option)
        option_ch.push(item.title)
      })

      field_name = field_name.join('-')
      option = option.join('-')
      option_ch = option_ch.join(';')

      insertFavorite(this.$store.state.userInfo.id,{field_name,option,option_ch,favorite_name}).then(result => {
        if(result.header && result.header.status === '200'){
          this.setToastMsg(result.header.message)
          this.panelClose('searchResultFarvoriteOpen')
        }else{
          this.setToastMsg(result.header.message)
        }
        this.loading = false
      })
    },
    openPrintModal () {
      //排序從[點選順序]變更為[目前Table的排序]
      this.selection = this.sortByPattern('id', this.tableDataBackup, this.selection)
      this.selectionWithMobile = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableDataBackup.find(data => {
          return data.id === sel;
        });
        if(tmpData) {
          this.selectionWithMobile.push(tmpData);
        }
      });
      this.panelOpen('printModalOpen')
    },
    sortByPattern(propertyStr, patternObjectArray, targetArray) {
      var targetWithIndexArray = []
      var targetCount = targetArray.length
      var patternCount = patternObjectArray.length
      for(var i=0; i<targetCount; i++) {
        var targetProperty = targetArray[i]
        for(var j=0; j<patternCount; j++) {
          if(targetProperty == patternObjectArray[j][propertyStr]) {
            var obj = {}
            obj['index'] = j
            obj[propertyStr] = targetProperty
            targetWithIndexArray.push(obj)
            break;
          }
        }
      }
      var sortedArray = targetWithIndexArray.sort(this.sortCompareFun(1, 'index'))
      return sortedArray.map((ele) => {return ele[propertyStr]})
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    },
    //切換生日排序方式
    changeBirthdaySort(val) {
      if (val == this.birthday_sort) {
        return;
      }
      this.$refs.dataTable.columnSorting(5);
      this.maskContent = "儲存預設生日排序中，請稍候...";
      this.panelOpen("mxMaskOpen"); //開啟遮罩
      if (val == "1") {
        deleteBirthSort(this.$store.state.userInfo.id).then(() => {
          this.panelClose("mxMaskOpen"); //關閉遮罩
        });
      } else {
        insertBirthSort(this.$store.state.userInfo.id).then(() => {
          this.panelClose("mxMaskOpen"); //關閉遮罩
        });
      }
    },
    //計算泰好客加權分數
    getMktScore(data) {
      if (!data.source || data.source.source1 != "1") {
        return -1; //目前無泰好客資訊，則分數為-1
      }
      let mktType = ["hos_mkt_level", "sur_mkt_level", "rei_mkt_level",
       "acc_mkt_level", "dd_mkt_level", "ltc_mkt_level", "life_mkt_level", "sav_mkt_level", "inv_mkt_level"];
      let returnScore = 0;

      //類型為1(分數2)，類型為2 or 3 (分數1)，其餘分數0
      mktType.forEach(value => {
        if (data[value] == "1") {
          returnScore += 2;
        } else if(data[value] == "2" || data[value] == "3") {
          returnScore += 1;
        }
      });

      return returnScore;
    },
    sortByName() {
      if(this.tableDataBackup.length == 0) {
        return;
      }
      
      let tempData = this.tableDataBackup;
      this.tableDataBackup = [];
      this.remoteDataMsg = "資料排序中，請稍候...";
      doSortList(
        this.$store.state.userInfo.id,
        this.order.order_asc ? "1" : "-1",
        tempData,
        "name"
      ).then(result => {
        if (result.header && result.header.status === "200") {
            this.tableDataBackup = result.body.result;
            this.tableDataBackup.forEach((item, index) => {
              item.index = `${index + 1}`;
            } );
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "姓名排序異常,請重新操作" });
          }
          this.tableDataBackup = tempData;
        }
        this.remoteDataMsg = "查無資料，請確認您輸入之資料是否正確";
      });
    },
    columnSorting (fieldName) {
      console.log(`>>>>> columnSorting:${fieldName} <<<<<`)
      //切換表頭圖案
      if(this.order.fieldName == fieldName) {
          this.order.asc = !this.order.asc
      } else {
        console.log('change sort field')
        this.order.fieldName = fieldName
        this.order.asc = true
        console.log(this.order)
      }

      //data排序
      let sortOrder = -1
      if(this.order.asc) {
        sortOrder = 1
      }

      switch (fieldName) {
        // case 'tel':
        //   this.tableDataBackup = []  
        //   setTimeout(() => {
        //   this.tableDataBackup = [...this.tableData]
        //   this.tableDataBackup.sort(this.numberCompareFun(sortOrder, fieldName))
        //   this.registerHanlink() // 難字顯示
        //   }, 20)
        //   break;
        case 'birthday':
          this.tableDataBackup = []  
          setTimeout(() => {
          this.setTableDataBackup(); //依勾選的客戶類型set TableDataBackup的資料
          this.tableDataBackup.sort(this.dateCompareFun(sortOrder, fieldName))
          this.tableDataBackup.sort(this.dateYearCompareFun(sortOrder, 'idage', 'birthday'))
          this.registerHanlink() // 難字顯示
          }, 20)
          break;
        case 'name': //2020/06/01 若是點姓名欄位，打到後台重取資料順便排序
          this.tableDataBackup = []  
          this.getCustomersAndSetup(this.$store.state.userInfo.id, this.keyword)
          break;
        case 'mkt_type': 
          this.tableDataBackup = []  
          this.getCustomersAndSetup(this.$store.state.userInfo.id, this.keyword)
          break;
        default:
          this.tableDataBackup = []  
          setTimeout(() => {
          this.setTableDataBackup(); //依勾選的客戶類型set TableDataBackup的資料
          this.tableDataBackup.sort(this.sortCompareFun(sortOrder, fieldName))
          this.registerHanlink() // 難字顯示
          }, 20)
      }
    }, 
    setTableDataBackup() {//依勾選的客戶類型set TableDataBackup的資料
      this.tableDataBackup = this.tableData.filter(item => {
        if (this.customerType.includes("1") && item.sourceFilter.includes("1")) {
          return item;
        }
        if (this.customerType.includes("2") && item.sourceFilter.includes("2")) {
          return item;
        }
        if (this.customerType.includes("3") && item.sourceFilter.includes("3")) {
          return item;
        }
        if (this.customerType.includes("4") && item.sourceFilter.includes("4")) {
          return item;
        }
        if (this.customerType.includes("5") && item.sourceFilter.includes("5")) {
          return item;
        }
        if (item.sourceFilter.length === 1 && this.customerType.includes("6") && item.sourceFilter.includes("6")) {
          return item;
        }
      });
    },
    dateCompareFun(sortOrder, property) {
      let vm = this
      return function(a, b) {

        
        // let aBir = a[property].replace(/\/.*/g, '') * 1 + 1911 + a[property].replace(/^.*(?=\/\d{2}\/)/, '')          
        // let bBir = b[property].replace(/\/.*/g, '') * 1 + 1911 + b[property].replace(/^.*(?=\/\d{2}\/)/, '')
        let date_a = a[property] ? moment(a[property]).format("1800/MM/DD"):'01-01';
        let date_b = b[property] ? moment(b[property]).format("1800/MM/DD"):'01-01';
        let result = (moment(date_a).isBefore(date_b)) ? -1 : 1;
        return result * sortOrder
      }
    },
    dateYearCompareFun(sortOrder, idage, birthay) {
      return function(a, b) {
        let date_a = a[birthay] ? moment(a[birthay]).format("MM/DD"):'01-01';
        let date_b = b[birthay] ? moment(b[birthay]).format("MM/DD"):'01-01';
        if((moment(date_a).isSame(date_b))) {
          let result = (a[idage] < b[idage]) ? -1 : (a[idage] > b[idage]) ? 1 : 0;
          return result * sortOrder
        }
        return 0
      }
    },
    filterByType() {
      this.checkAll = false
      this.selection = []
      this.tableDataBackup = []  
      setTimeout(() => {
        this.tableDataBackup = this.tableData.filter(item => {
          if(this.customerType.includes('1') ){
            if(item.sourceFilter.includes('1')){
              return item
            }
          }
          if(this.customerType.includes('3') ) {
            if(item.sourceFilter.includes('3')){
              return item
            }
          }
          if(this.customerType.includes('4') ) {
            if(item.sourceFilter.includes('4')){
              return item
            }
          }
          if(this.customerType.includes('5') ) {
            if(item.sourceFilter.includes('5')){
              return item
            }
          }
          if(this.customerType.includes('6') ) {
            if (
              item.sourceFilter.length === 1 &&
              item.sourceFilter.includes('6')
            ) {
              return item
            }
          }                                                
        })

        this.tableDataBackup.forEach((item, index) => {
          item.index = `${index + 1}`;tableDataBackup
        });
        this.registerHanlink() // 難字顯示
      }, 20)
     
      // this.tableDataBackup = this.tableDataBackup.map(item => {
      //   console.log(item);
      // })
      
      // this.tableDataBackup = templist
      // setTimeout(() => {
      //   let templist = []
      //   this.tableDataBackup = this.tableDataBackup.forEach(item => {
      //     if(this.customerType.includes(item.idmark))
      //     {
      //       templist.push(item)
      //     }
      //   })
      //   console.log(templist);
      //   this.tableDataBackup = [...this.templist]
      //   this.registerHanlink() // 難字顯示
      // }, 20)      
    },
    deleteCustomer () {
      this.maskContent = "資料刪除中，請稍候...";
      this.panelOpen("mxMaskOpen");//開啟遮罩
      deleteCust(this.$store.state.userInfo.id, "csids", "", "",this.selection).then(result =>{
        this.panelClose("mxMaskOpen");//關閉遮罩
        if (result && result.header.status == '200') {
          this.panelClose('WarningDoubleCheckModalOpen')
          this.$toast.info({title: `刪除成功`})
          this.$router.push({path:`/`})
        }
        else {  
          this.panelClose('WarningDoubleCheckModalOpen')
          this.$toast.info({title: `刪除失敗`})
        }
      })  
    },
    handleScroll() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
      // ----滾動顯示/隱藏----
    },
    getCustomersPageNew() {
      this.addPageStatus = true;
      const begin = (this.currentPage - 1) * this.pageSize;
      this.tableDataBackup.push(...this.tableData.slice(begin, begin + this.pageSize));
      
      if (this.currentPage !== this.totalpages) {
        this.scrollMessageLoading = false;
        this.scrollDataLoading = false;
      } else {
        this.scrollMessageLoading = false;
      }

      setTimeout(() => {
        this.registerHanlink()
      }, 2000);
    },
    //取得主(附)約商品中文名稱
    getFiltersProdCode() {
      this.filtersProdCode = [];
      this.filters.forEach(item => {
        if (!item || item == "undefined") return;
        let mainCode = item.indexOf('主約');
        let subCode = item.indexOf('附約');
        let prodTypeMain = item.indexOf('已投商品:');
        if(mainCode !== -1 && subCode !== -1) {
          //有主約&附約
          let mainText = item.substring(mainCode + 3, subCode).split(':').map(m => {
            let mainAry = this.$store.state.prodMainCode.filter(main => { return main.val == m});
            let chkMainAry = mainAry && mainAry.length > 0 ? true : false;
            return {
              text: chkMainAry ? mainAry[0].text : m
            }
          })
          let subText = item.substring(subCode + 3, item.length).split(':').map(s => {
            let subAry = this.$store.state.prodSubCode.filter(main => { return main.val == s});
            let chkSubAry = subAry && subAry.length > 0 ? true : false;
            return {
              text: chkSubAry ? subAry[0].text : s
            }
          })
          let filterStr = prodTypeMain !== -1 ? '已投商品:主約:' : '未投商品:主約';
          mainText.forEach(mt => { filterStr += mt.text + ':'});
          filterStr+= '附約:';
          subText.forEach(st => { filterStr += st.text + ':'});
          this.filtersProdCode.push(filterStr.substring(0, filterStr.length -1));
        } else if (mainCode !== -1) {
          //只有主約
          let mainText = item.substring(mainCode + 3, item.length).split(':').map(m => {
            let mainAry = this.$store.state.prodMainCode.filter(main => { return main.val == m});
            let chkMainAry = mainAry && mainAry.length > 0 ? true : false;
            return {
              text: chkMainAry ? mainAry[0].text : m
            }
          })
          let filterStr = prodTypeMain !== -1 ? '已投商品:主約:' : '未投商品:主約';
          mainText.forEach(mt => { filterStr += mt.text + ':'});
          this.filtersProdCode.push(filterStr.substring(0, filterStr.length -1));
        } else if (subCode !== -1) {
          //只有附約
          let subText = item.substring(subCode + 3, item.length).split(':').map(s => {
            let subAry = this.$store.state.prodSubCode.filter(main => { return main.val == s});
            let chkSubAry = subAry && subAry.length > 0 ? true : false;
            return {
              text: chkSubAry ? subAry[0].text : s
            }
          })
          let filterStr = prodTypeMain !== -1 ? '已投商品:附約:' : '未投商品:附約';
          subText.forEach(st => { filterStr += st.text + ':'});
          this.filtersProdCode.push(filterStr.substring(0, filterStr.length -1));
        } else {
          //非商品類別條件，直接塞值
          this.filtersProdCode.push(item);
        }
      })
    },
    //導頁至加入現有群組(view)
    addToCurrentGroup() {
      this.panelClose("confirmGroupModalOpen");
      let selectionInfo = this.getSelectedCustInfo();
      this.$router.push({
        name: "add-to-current-group",
        params: { selectedCust: selectionInfo }
      });
    },
    //開啟成立新的群組視窗
    createOneGroupOpen() {
      this.panelClose("confirmGroupModalOpen");
      this.panelOpen("createOneGroupModalOpen");
    },
    //導頁至成立新的群組(view)
    createOneGroup(groupName) {
      let selectionInfo = this.getSelectedCustInfo();
      this.panelClose("createOneGroupModalOpen");
      this.$router.push({
        name: "create-one-group",
        params: { selectedCust: selectionInfo, groupName: groupName }
      });
    },
    //取得當前勾選客戶的資料
    getSelectedCustInfo() {
      let selectionInfo = [];
      this.selection.forEach(sel => {
        let tmpData = this.tableData.find(data => {
          return data.id === sel;
        });
        if (tmpData) {
          selectionInfo.push({
            showid: tmpData.id.startsWith("~") ? "" : tmpData.id,
            id: tmpData.id,
            name: tmpData.name,
            birthday: tmpData.birthday
          });
        }
      });
      return selectionInfo;
    },
    //開啟泰好客說明視窗
    openCathayCustInfoModal () {
      this.panelOpen('cathayCustInfoModalOpen');
    },
    //開啟問卷視窗
    openCathaySurveyModal(cust) {
      this.selectedCustID = cust.id
      this.panelOpen('surveyModalOpen');
    },
    //關閉問卷並更新問券狀態
    doRefresh() {
      this.panelClose('surveyModalOpen');
      this.tableDataBackup.forEach((item) => {
        if (item.id == this.selectedCustID && item.crm_highlight == "1") {
          item.crm_highlight = "0";
        }
      });

      this.tableData.forEach((item) => {
        if (item.id == this.selectedCustID && item.crm_highlight == "1") {
          item.crm_highlight = "0";
        }
      });
    }
  },
  async mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.getCustomersAndSetup()

    let self = this;
    $(window).bind('orientationchange', function(event) {
      $(window).one('resize', function() {
        self.tableOption.scrollHeight = $(window).height() - 310
      });
    });
  },
}
</script>
<style lang="scss" scoped>
.dropdown-menu-left {
  left: -16px !important;
}
.filter-result-table thead tr,.filter-result-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.list.badgets .badget.gray.item {
    padding: 0 22px;
    color: #323a45;
    background: #e0e1e3;
    border-radius: 8px;
    margin-right: 10px;
    margin-top: 10px;
}

.filter-result-table tbody {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
  @media screen and (max-width: 1024px){

    #datatable{
      width: 77rem;
    }
  }

  @media screen and (max-width: 768px){

    #datatable{
      width: 70rem;
    }
  }
}
.boxPadding {
  padding-top: 0px !important;
}

.w-180 {
  width:180px;
}
</style>